import React from 'react';
import { Wrapper } from './index.styles';
import Sidebar from './components/sidebar';
import AppBar from './components/app-bar';
import Main from './components/main';
import AppLogo from './components/app-logo';

const LayoutPrivate: React.FC = ({ children }) => {
    return (
        <Wrapper>
            <Sidebar />
            <AppBar />
            <AppLogo />
            <Main>{children}</Main>
        </Wrapper>
    );
};

export default LayoutPrivate;
